export default __webpack_public_path__ + "static/media/d41a883982ec3682.ab247ef4542ab394882aa198e6a4f05c.svg";